import React, { useEffect, useRef, useState } from "react";
import styles from "./Menu.module.css";
import ProjectionItem from "./ProjectionItem";
import EarlyWarningItem from "./EarlyWarningItem";
import SatelliteImageryItem from "./SatelliteImageryItem";
import IncidentsMenuDropDown from "../../mainLayer/hazardIncidentsLayers/IncidentsMenuDropDown";

type MenuItemPropType = {
    id: number;
    title: string;
    img: string;
  };
  
  type MenuTabPropsType = {
    id: number;
    title: string;
    type: string;
    itemDetails: Array<MenuItemPropType>;
    popupLayerType: string;
    passStartDurationForm: (from: string) => void;
    passFromDurationTo: (to: string) => void;
    endTime: string;
    playTimer: boolean;
    showTimeRangeNotification: (show: boolean) => void;
    setOpenTab: (id: number) => void;
    openTabId:number | null;
    passClickedHzIncidentMapValue: (clicked: boolean) => void;
    timeLineHour: string
    timeLineDate: string
    sensorType: (value: string) => void;
    openModular: (value: string) => void;
    renderHz: (value: boolean) => void;
  };
  
  const IncidentMenuTab = ({ id, title, type, itemDetails, popupLayerType,passStartDurationForm,
    passFromDurationTo,   endTime,
    playTimer,
    showTimeRangeNotification,
    setOpenTab,
    openTabId,passClickedHzIncidentMapValue,
    timeLineHour,
    timeLineDate,
    sensorType,
    openModular,
    renderHz
  }: MenuTabPropsType) => {
   
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(true);
    const [itemList, setItemList] = useState<Array<MenuItemPropType>>(itemDetails);
    const isUserToggled = useRef<boolean>(false); 
  
    
    useEffect(() => {
      // setIsMenuOpen(popupLayerType === title);
      if(popupLayerType === title){
        setOpenTab(id); 
      }
    }, [popupLayerType, title]);

    useEffect(() => {
      if(openTabId !== id){
        // setIsMenuOpen(false); 
      }
    }, [openTabId]);
  
    useEffect(() => {
    }, [isMenuOpen]);
  
    const TabToggleSwitch = () => {
      setIsMenuOpen((prevState) => !prevState);
      // isUserToggled.current = true; 
      setOpenTab(id);
    };
  
   
    const dragItem = useRef<number>(0);
    const dragOver = useRef<number>(0);
  
   
    const handleSort = () => {
      const layerList = [...itemList];
      const temp = layerList[dragItem.current];
      layerList[dragItem.current] = layerList[dragOver.current];
      layerList[dragOver.current] = temp;
      setItemList(layerList);
    };
  


    return (
      <div key={id} className={styles.menuTabContainer}>
        <div
          className={styles.titleContainer}
          onClick={TabToggleSwitch}
          onTouchStart={TabToggleSwitch}
          style={{ backgroundColor: `${isMenuOpen ? "var(--menu-tab-open-color)" : "var(--menu-main-color)"}` }}
        >
          <img
            src={isMenuOpen ? require("../../assets/drop.png") : require("../../assets/up.png")}
            alt=""
          />
          <span>{title}</span>
        </div>
        <div
          className={styles.contentContainer}
          style={{
            height: `${isMenuOpen ? "150px" : "0.4px"}`,
            flexDirection: `${type === "basecamp" || type === "projection" ? "row" : "column"}`,
            justifyContent: `${type === "basecamp" || type === "projection" ? "center" : ""}`,
            padding: `${(type === "basecamp" || type === "projection") && isMenuOpen ? "10px" : "0"}`,
          }}
        >
          {type === "layer" &&
            itemList?.map((item, index) => (
                   <IncidentsMenuDropDown
                passStartDurationForm={passStartDurationForm}
                passFromDurationTo={passFromDurationTo}
                endTime={endTime}
                playTimer={playTimer}
                showTimeRangeNotification={() => {
                    showTimeRangeNotification(true);
                }}
                key={item.id}
                id={item.id}
                index={index}
                title={item.title}
                dragItemRef={dragItem}
                dragOverRef={dragOver}
                handleSort={handleSort}
                passClickedHzIncidentMapValue={passClickedHzIncidentMapValue}
                menuOpen={isMenuOpen}
                timeLineHour={timeLineHour}
                timeLineDate={timeLineDate}
                sensorType={sensorType} openModular={openModular} renderHz={renderHz}
              />
            ))}
        </div>
      </div>
    );
    
  };


export default IncidentMenuTab;